import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Download, Heart } from 'lucide-react';
import { toast } from 'sonner';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const DownloadSection = () => {
  const [downloading, setDownloading] = useState(false);

  const handleDownloadAll = async () => {
    setDownloading(true);
    try {
      toast.info('Preparing your download... This may take a moment.');
      
      // Open download in new window
      window.open(`${API_BASE}/api/photos/download/all`, '_blank');
      
      setTimeout(() => {
        toast.success('Download started!');
      }, 500);
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download photos');
    } finally {
      setTimeout(() => {
        setDownloading(false);
      }, 1000);
    }
  };

  return (
    <section className="py-16 sm:py-20 bg-primary/5" data-testid="couple-download-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mx-auto"
        >
          <Card className="gold-border shadow-[0_12px_30px_rgba(18,58,42,0.08)]">
            <CardHeader className="text-center">
              <CardTitle className="flex items-center justify-center gap-2 font-serif text-2xl">
                <Heart className="w-5 h-5 text-primary" />
                For Robyn & Angelo
              </CardTitle>
              <CardDescription>
                Download all photos from your special weekend
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground text-center">
                Click below to download all photos as a ZIP file. 
                All photos will be included with the uploader's name.
              </p>
              <Button
                size="lg"
                className="w-full"
                onClick={handleDownloadAll}
                disabled={downloading}
                data-testid="download-all-photos-button"
              >
                {downloading ? (
                  <span className="flex items-center gap-2">
                    <span className="animate-pulse">Preparing...</span>
                  </span>
                ) : (
                  <span className="flex items-center gap-2">
                    <Download className="w-4 h-4" />
                    Download All Photos
                  </span>
                )}
              </Button>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};

export default DownloadSection;